<template>
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 account_section">
    <div class="my-account-title" v-if="FormInputs.IndividualLabels">Professional Information</div>
     <div class="my-account-title" v-else>Eye Doctor Information</div>
    <div class="account_login_info">
      <div v-for="(doctorItem, index) in AccountView.eyeDoctors">
        <div class="row">
          <div class="col-lg-10 col-md-10 col-sm-10 col-xs-10">
            <div class="row" v-show="FormInputs.EyeDoctorName">
              <div class="col-lg-5 col-md-5 col-sm-5 col-xs-5">
                <label class="account_label capitalized-text">Name</label>
              </div>
              <div class="col-lg-7 col-md-12 col-sm-12 col-xs-12">
                <p class="account_p" v-if="(doctorItem.suffix == 'N/A' || doctorItem.suffix == '')">{{doctorItem.firstName + " " + doctorItem.lastName}}</p>
                <p class="account_p" v-else>{{doctorItem.firstName + " " + doctorItem.lastName + ", " + doctorItem.suffix}}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-5 col-md-5 col-sm-5 col-xs-5">
                <label class="account_label">NPI Number</label>
              </div>
              <div class="col-lg-7 col-md-7 col-sm-7 col-xs-7">
                <p class="account_p">{{doctorItem.npiNumber}}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-5 col-md-5 col-sm-5 col-xs-5">
                <label class="account_label">License Number/State</label>
              </div>
              <div class="col-lg-7 col-md-7 col-sm-7 col-xs-7">
                <p class="account_p" v-if="doctorItem.licenseNumber && doctorItem.state && doctorItem.useLicenseNumber == true">{{IsEmpty(IsNull(doctorItem.licenseNumber)) + IsNull(doctorItem.state)}}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-5 col-md-5 col-sm-5 col-xs-5">
                <label class="account_label">Year Licensed</label>
              </div>
              <div class="col-lg-7 col-md-7 col-sm-7 col-xs-7">
                <p class="account_p" v-if="doctorItem.yearsInPractice">{{doctorItem.yearsInPractice}}</p>
              </div>
            </div>
            <div class="row" v-show="FormInputs.EyeDoctorEmail">
              <div class="col-lg-5 col-md-5 col-sm-5 col-xs-5">
                <label class="account_label">Doctor's Email Address</label>
              </div>
              <div class="col-lg-7 col-md-7 col-sm-7 col-xs-7">
                <p class="account_p">{{doctorItem.emailAddress}}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-5 col-md-5 col-sm-5 col-xs-5">
                <label class="account_label">Professional Associations</label>
              </div>
              <div class="col-lg-7 col-md-7 col-sm-7 col-xs-7">
                <ul class="eyeDoctorAssociation_info" style="list-style: none; padding-left: 0px" v-if="doctorItem.organizations">
                  <li v-for="(value, key) in doctorItem.organizations.list" v-if="value!='Other'">{{value}}</li>
                  <li v-if="doctorItem.organizations.others">{{doctorItem.organizations.others}}</li>
                </ul>
                <p class="account_p"></p>
              </div>
            </div>

        </div>
        <div class="col-lg-2 col-md-12 col-xs-12 col-sm-12">
          <button class="btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-btn-85 g-mb-10 g-font-size-17" v-on:click="EditSection(index)">Edit</button>
          <button class="btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-btn-85 g-font-size-17" v-on:click="ShowDeleteDoctorModal(index)">Delete</button>
        </div>
      </div>
      <p v-if="isOneDoctorRemain" class="error-message">The account requires at least one doctor be associated</p>
    <hr>
      </div>
      <div v-show="FormInputs.ProfessionalInfo">
          <div class="row">
            <div class="col-lg-5 col-md-5 col-sm-5 col-xs-5">
              <label class="account_label">NPI Number</label>
            </div>
            <div class="col-lg-7 col-md-7 col-sm-7 col-xs-7">
              <p class="account_p">{{AccountView.npiNumber}}</p>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-5 col-md-5 col-sm-5 col-xs-5">
              <label class="account_label">License Number/State</label>
            </div>
            <div class="col-lg-7 col-md-7 col-sm-7 col-xs-7">
              <p class="account_p" v-if="AccountView.licenseNumber && AccountView.state && AccountEdit.useLicenseNumber == true">{{IsEmpty(IsNull(AccountView.licenseNumber)) + IsNull(AccountView.state)}}</p>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-5 col-md-5 col-sm-5 col-xs-5">
              <label class="account_label">Year Licensed</label>
            </div>
            <div class="col-lg-7 col-md-7 col-sm-7 col-xs-7">
              <p class="account_p" v-if="AccountView.primaryContact.yearsInPractice">{{AccountView.primaryContact.yearsInPractice}}</p>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-4 col-md-12 col-sm-12 col-xs-12">
              <label class="account_label">Professional Associations</label>
            </div>
            <div class="col-lg-7 col-md-12 col-sm-12 col-xs-12">
              <ul class="association_info" v-if="AccountView.organizations">
                <li v-for="(value, key) in AccountView.organizations.list" v-if="value!='Other'">{{value}}</li>
                <li v-if="AccountView.organizations.others">{{AccountView.organizations.others}}</li>
              </ul>
            </div>
          </div>
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 center">
            <button class="btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-btn-130 g-font-size-17" v-on:click="EditProfessional()">Edit</button>
          </div>
      </div>
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 center">
        <button class="btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-btn-200 g-font-size-17" v-show="FormInputs.AddEyeDoctor" v-on:click="ShowAddDoctorModal()">Add Another Doctor</button>
      </div>
    </div>
    <loading-component v-if="isLoading"></loading-component>
    <div v-if="isModalShown">
      <edit-eye-doctor-info v-show="FormInputs.EyeDoctorInformation"
              @modalClick="ShowModal()"
              @saveDoctorChanges="SaveAccount()"
              @npiIsDirty="ValidateNpiNumberEyeDoctor(eyeDoctorActiveIndex)"
              v-bind:AccountEdit="AccountEdit"
              :AccountView="AccountView"
              :eyeDoctorActive="eyeDoctorActive"
              :eyeDoctorActiveIndex="eyeDoctorActiveIndex"
              :FormInputs="FormInputs"
              :Suffix="Suffix"
              :State="State"
              :CheckboxIndividual="CheckboxIndividual"
              :isFormLoading="isFormLoading"
              :EyeDoctorValidation="EyeDoctorValidation">
      </edit-eye-doctor-info>
      <edit-professional-info v-show="FormInputs.ProfessionalInfo"
              @modalClick="ShowModal()"
              @saveProfessional="SaveProfessionalInfo()"
              @npiIsDirty="ValidateNpiNumber()"
              v-bind:AccountEdit="AccountEdit"
              :FormInputs="FormInputs"
              :Suffix="Suffix"
              :State="State"
              :CheckboxIndividual="CheckboxIndividual"
              :AccountValidationResult="AccountValidationResult"
              :isFormLoading="isFormLoading">
      </edit-professional-info>
    </div>

    <!--Delete Doctor Modal Confirmation-->
    <div v-if="isDeleteModalShown">
      <delete-modal
              @modalClose="ShowDeleteDoctorModal()"
              @delete="DeleteDoctor()"
              v-bind:AccountView="AccountView"
              :FormInputs="FormInputs"
              :Suffix="Suffix"
              :State="State"
              :CheckboxIndividual="CheckboxIndividual"
              :isFormLoading="isFormLoading"
              :eyeDoctorActiveIndex="eyeDoctorActiveIndex">
      </delete-modal>
    </div>

    <!--Delete Doctor Modal Confirmation-->
    <div v-if="isAddModalShown">
      <add-doctor @modalClose="ShowAddDoctorModal()"
              @AddEyeDoctor="AddDoctorInfo()"
              @npiIsDirty="ValidateNpiNumberNewDoctor()"
              v-bind:AccountView="AccountView"
              :AccountEdit="AccountEdit"
              :FormInputs="FormInputs"
              :Suffix="Suffix"
              :State="State"
              :CheckboxIndividual="CheckboxIndividual"
              :isFormLoading="isFormLoading"
              :eyeDoctorActiveIndex="eyeDoctorActiveIndex"
              :NewDoctor="NewDoctor"
              :NewDoctorValidationResult="NewDoctorValidationResult">
      </add-doctor>
    </div>

  </div>
</template>
<script>
import EditEyeDoctorInfo from "@/components/portal/userAccount/accountEdit/EditEyeDoctorInfo";
import EditProfessionalInfo from "@/components/portal/userAccount/accountEdit/EditProfessionalInfo";
import LoadingComponent from "@/components/shared/LoadingComponent";
import DeleteModal from "@/components/portal/userAccount/accountList/DeleteModal";
import AddDoctor from "@/components/portal/userAccount/accountList/AddDoctor";
export default {
  props: ['AccountView',
          'AccountEdit',
          'FormInputs',
          'Suffix',
          'State',
          'CheckboxIndividual',
          'isFormLoading',
          'NewDoctor',],
  components: {EditEyeDoctorInfo, LoadingComponent, EditProfessionalInfo, DeleteModal, AddDoctor},
  data(){
    return{
      isModalShown: false,
      isLoading: false,
      isDeleteModalShown: false,
      eyeDoctorActive: {},
      eyeDoctorActiveIndex: null,
      AccountValidationResult: {},
      isAddModalShown: false,
      EyeDoctorValidation: {},
      NewDoctorValidationResult: {},
      isOneDoctorRemain:false
    }
  },
  methods: {
    EditSection(index) {
      document.body.classList.add("body-overflow");
      this.eyeDoctorActiveIndex = index;
      this.AccountEdit.eyeDoctorActiveIndex = index;
      this.EyeDoctorValidation = {};
      this.isModalShown = !this.isModalShown;
      this.$emit("load");
      this.$emit("clicked");
    },
    EditProfessional() {
      this.AccountValidationResult = {};
      this.ContactValidationResult = {};
      this.isModalShown = !this.isModalShown;
      this.$emit("load");
      this.$emit("clicked");
    },
    ShowModal() {
      this.isModalShown = !this.isModalShown;
    },
    ShowDeleteDoctorModal(index){
      if(this.AccountView.eyeDoctors.length > 1){
        document.body.classList.add("body-overflow");
        this.AccountView.eyeDoctorActiveIndex = index;
        this.eyeDoctorActiveIndex = index;
        this.isDeleteModalShown = !this.isDeleteModalShown;
      }else{
        this.isOneDoctorRemain = true;
      }
    },
    SaveAccount() {
      this.isLoading = true;
      var doctor = this.AccountEdit.eyeDoctors[this.eyeDoctorActiveIndex];
      axios
        .post("/Account/EyeDoctor/Update/" + this.AccountView.salesforceId ,doctor , {
          headers: { Authorization: "Bearer " + localStorage.getItem("token") }
        })
        .then(response => {
          var _this = this;
          _this.isLoading = false;
          if (response.data.isSuccess == true) {
            _this.$emit("selfReload");
            _this.CloseEyeDoctorModal();
            _this.$emit("success");
          } else {
            _this.EyeDoctorValidation = response.data.raw.validationResult;
            console.log("Error in Saving!");
            console.log(response);
          }
        })
        .catch(function(error) {
          console.log(error);
          _this.$router.push({name: 'Error'});
        });
    },
    CloseEyeDoctorModal(){
      this.isModalShown = !this.isModalShown;
    },
    SaveProfessionalInfo() {
      this.isLoading = true;
      this.AccountValidationResult = {};
      axios
        .post("/Account/ProfessionalInformation", this.AccountEdit, {
          headers: { Authorization: "Bearer " + localStorage.getItem("token") }
        })
        .then(response => {
          var _this = this;
          _this.isLoading = false;
          if (response.data.isSuccess == true) {
            _this.$emit("selfReload");
            _this.CloseEyeDoctorModal();
            _this.$emit("success");
          } else {
            _this.AccountValidationResult = response.data.raw.validationResult;
            console.log("Error in Saving!");
            console.log(response);
          }
        })
        .catch(function(error) {
          console.log(error);
          _this.$router.push({name: 'Error'});
        });
    },
    DeleteDoctor() {
      this.isLoading = true;
      var doctor = this.AccountEdit.eyeDoctors[this.eyeDoctorActiveIndex];
      axios
        .post("/Account/EyeDoctor/Delete", doctor, {
          headers: { Authorization: "Bearer " + localStorage.getItem("token") }
        })
        .then(response => {
          var _this = this;
          _this.isLoading = false;
          if (response.data.isSuccess == true) {
            _this.$emit("selfReload");
            _this.isDeleteModalShown = false;
            _this.$emit("success");
          } else {
            console.log("Error in Saving!");
            console.log(response);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    ShowAddDoctorModal() {
      document.body.classList.add("body-overflow");
      this.isAddModalShown = !this.isAddModalShown;
      this.$emit("refreshDoctorForm");
      this.NewDoctorValidationResult = {};
    },
    AddDoctorInfo(){
      this.isLoading = true;
        axios
        .post("/Account/EyeDoctor/Create/" + this.AccountView.salesforceId, this.NewDoctor , {
          headers: { Authorization: "Bearer " + localStorage.getItem("token") }
        })
        .then(response => {
          var _this = this;
          _this.isLoading = false;
          if (response.data.isSuccess == true) {
            _this.isAddModalShown = false;
            _this.$emit("selfReload");
            _this.$emit("success");
          } else {
            _this.NewDoctorValidationResult = response.data.raw.validationResult;
            console.log("Error in Saving!");
            console.log(response);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    RefreshEyeDoctorValidation(){
      this.EyeDoctorValidation= [];
      var numberOfDoc = this.AccountEdit.eyeDoctors.length;
      for(var i = 0; i < numberOfDoc; i++){
        this.EyeDoctorValidation.push({validationResult: {}});
      }
    },
    ValidateNpiNumber() {
      var _this     = this;
      var npiNumber = _this.AccountEdit.npiNumber;
      if(npiNumber.length == 10){
        _this.isLoading = true;

        _this.AccountEdit.AccountType = this.$route.params.type;
        axios.post('/Account/IsNpiNumberValid/', _this.AccountEdit)
        .then(response => {
            if(response.data.isSuccess)
            {
                _this.AccountValidationResult = {AccountNpiNumber: null};

                var details      = response.data.raw.results[0];
                var basicDetails = details.basic;
                var address      = details.addresses[0];

                _this.AccountEdit.primaryContact.firstName   = basicDetails.first_name;
                _this.AccountEdit.primaryContact.lastName    = basicDetails.last_name;
                _this.AccountEdit.primaryContact.suffix      = basicDetails.credential;
                _this.AccountEdit.primaryContact.countryCode = address.telephone_number.split('-')[0];
                _this.AccountEdit.primaryContact.areaCode    = address.telephone_number.split('-')[1];
                _this.AccountEdit.primaryContact.phone       = address.telephone_number.split('-')[2];

                _this.isLoading = false;
            }
            else
            {
                _this.AccountValidationResult = {AccountNpiNumber:response.data.errorMessage};
                _this.called     = _this.AccountValidationResult.AccountNpiNumber;

                _this.AccountEdit.primaryContact.firstName   = null;
                _this.AccountEdit.primaryContact.lastName    = null;
                _this.AccountEdit.primaryContact.suffix      = null;
                _this.AccountEdit.primaryContact.countryCode = null;
                _this.AccountEdit.primaryContact.areaCode    = null;
                _this.AccountEdit.primaryContact.phone       = null;

                _this.isLoading = false;

            }
        })
        .catch(error => {
        console.log(error);
        });
      }
    },
    ValidateNpiNumberNewDoctor() {
      var _this     = this;
      var npiNumber = _this.NewDoctor.npiNumber;
      if(npiNumber.length == 10){
        _this.isLoading = true;

        _this.DoctorDetails =
        {
          AccountType: this.$route.params.type,
          NpiNumber: npiNumber
        };

        axios.post('/Account/IsNpiNumberValidEyeDoctor/', _this.DoctorDetails)
        .then(response => {
            if(response.data.isSuccess)
            {
                _this.NewDoctorValidationResult = {EyeDoctorNpiNumber: null};

                var details      = response.data.raw.results[0];
                var basicDetails = details.basic;
                var address      = details.addresses[0];

                _this.NewDoctor.firstName = basicDetails.first_name;
                _this.NewDoctor.lastName  = basicDetails.last_name;
                _this.NewDoctor.suffix    = basicDetails.credential;

                _this.isLoading = false;
            }
            else
            {
                _this.NewDoctorValidationResult = {EyeDoctorNpiNumber: response.data.errorMessage};

                _this.NewDoctor.firstName = null;
                _this.NewDoctor.lastName  = null;
                _this.NewDoctor.suffix    = null;

                _this.isLoading = false;
            }
        })
        .catch(error => {
        console.log(error);
        });
      }
    },
    ValidateNpiNumberEyeDoctor(index) {
      var _this = this;
      var npiNumber = _this.AccountEdit.eyeDoctors[index].npiNumber;
      if(npiNumber.length == 10){
        _this.isLoading = true;
        _this.AccountEdit.NpiNumber = npiNumber;

        axios.post('/Account/IsNpiNumberValidEyeDoctor/', _this.AccountEdit)
        .then(response => {
            if(response.data.isSuccess)
            {
              var details      = response.data.raw.results[0];
              var basicDetails = details.basic;
              var address      = details.addresses[0];

              _this.AccountEdit.eyeDoctors[index].firstName = basicDetails.first_name;
              _this.AccountEdit.eyeDoctors[index].lastName  = basicDetails.last_name;
              _this.AccountEdit.eyeDoctors[index].suffix    = basicDetails.credential;

              _this.EyeDoctorValidation = {EyeDoctorNpiNumber: null};
              _this.isLoading = false;
            }
            else
            {
              _this.AccountEdit.eyeDoctors[index].firstName = null;
              _this.AccountEdit.eyeDoctors[index].lastName  = null;
              _this.AccountEdit.eyeDoctors[index].suffix    = null;

              _this.EyeDoctorValidation = {EyeDoctorNpiNumber: response.data.errorMessage};

              _this.isLoading = false;
            }
        })
        .catch(error => {
        console.log(error);
        });
      }
    }
  },
  created(){
    this.RefreshEyeDoctorValidation();
  }
}
</script>



// WEBPACK FOOTER //
// EyeDoctorInfo.vue?64525de6